<template>
	<div class="display_wrapper">

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">{{listTitle}}</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_edit">
		    	<v-icon>edit</v-icon>
		    </v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>
		</v-toolbar>

		
		<div class="display hasToolbar">
			<div class="display_title">{{displayData.name}}</div>
		</div>

		<dialog-confirmation ref="ref_dialogDeleteConfirmation" header="Delete Master?" :actionMethod="fn_deleteMaster" params="delete" :displayView='true'></dialog-confirmation>

	</div>
</template>

<script>
const menuItem = require('../../../../../config.js').configs.menuItem;
import {masterMixin} from '../../../master_mixin.js'

import dialogConfirmation from '../../../../dialogs/dialog_confirmation'

	export default{
		mixins: [masterMixin],
		data(){
			return{
				displayData:{},
				listTitle:null
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation
		},
		methods:{
			// fn_edit: function(){
			// 	this.$router.push("/masters/lists/"+this.displayData.listId+"/items/"+this.displayData.listItemsId+"/edit")
			// },
			fn_get: function(itemId){
				var self = this;
				this.getData('ListItem', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.displayData = JSON.parse(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = this.listTitle;
				viewObject.TopMenu = [menuItem.edit];
				viewObject.isBottomMenu = true;

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';

				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				var bottomMenu = {"BottomMenu": [menuItem.copy]};
				!this.displayData.isSystem ? bottomMenu.BottomMenu.push(menuItem.delete) : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.listId && this.displayData.listItemsId){
					this.fn_edit();
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/masters/lists/'+this.displayData.listId+'/items/new', query:{tagId:this.guidWeb(), listTitle:this.listTitle, itemId:this.displayData.listItemsId, copy:true}});
				}
				else if(menuAction=='delete'){
					this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
				}
			},

			fn_deleteMaster: function(){
				let self = this;
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				this.fn_deleteMasterItem('listItems', this.displayData.listItemsId, function(response){
					if(response){
                        self.showToast('Item deleted');
                        self.$router.go(-1);
                    }
                    else{
                        self.showToast("Item cannot be deleted as already in use");
                    }
				})
			},

			fn_edit: function () {
				this.$router.push({path: "/masters/lists/"+this.displayData.listId+"/items/"+this.displayData.listItemsId+"/edit", query: {listTitle:this.listTitle}});
			}
		},

		mounted: function(){
			this.listTitle = this.$route.query.listTitle;
			
			this.fn_showWebView();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation){
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/lists/list_items/display.vue